<template lang="html">
  <section :id="id" class="custom-display-element-translations">
    <base-card>
      <template v-slot:header>
        <card-header :header-title="$t('translations')" />
      </template>
      <div>
        <custom-display-element-edit-translation
          v-for="translation in translations"
          :key="translation.uuid"
          :options="options"
          :translation="translation"
          :widgetuuid="$route.params.widgetuuid"
        />
        <custom-display-element-add-translation
          v-if="isAddTranslation"
          id="add-translation"
          :options="options"
          :widgetuuid="$route.params.widgetuuid"
          @on-remove-new-translation="onRemoveNewTranslation"
        />
      </div>
      <template v-slot:footer>
        <div v-if="!displayLoader">
          <button
            class="m-button outline-brand"
            @click="addTranslation"
            :disabled="isAddTranslation"
          >
            {{ $t("newTranslation") }}
          </button>
        </div>
      </template>
    </base-card>
    <div class="loader-wrap">
      <div class="loader" v-if="displayLoader"></div>
    </div>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import BaseCard from "@/components/card/BaseCard";
  import CardHeader from "@/components/card/CardHeader";
  import LocaleUtil from "@/utils/locales-util";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import CustomDisplayElementAddTranslation from "@/components/custom-display-elements/tabs/parts/CustomDisplayElementAddTranslation";
  import CustomDisplayElementEditTranslation from "@/components/custom-display-elements/tabs/parts/CustomDisplayElementEditTranslation";

  export default  {
    name: "custom-display-element-translations",
    components: {
      BaseCard,
      CardHeader,
      CustomDisplayElementAddTranslation,
      CustomDisplayElementEditTranslation
    },
    props: {
      id: String
    },
    data () {
      return {
        displayLoader: false,
        isAddTranslation: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      translations() {
        return this.isCurrentStoreData? this.widgetTranslations.translations : [];
      },
      isCurrentStoreData() {
        return this.widgetTranslations.widgetuuid === this.$route.params.widgetuuid;
      },
      widgetTranslations() {
        return this.$store.getters[MUTATION_NAME.WIDGET_TRANSLATIONS] || {};
      },
      options() {
        return LocaleUtil.locales();
      }
    },
    mounted () {
      if(!this.isCurrentStoreData) {
        this.displayLoader = true;
        DistributionChannelsService.widgetTranslations(this.$route.params.widgetuuid)
        .catch((e) => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
        });
      }
    },
    methods: {
      addTranslation() {
        this.isAddTranslation = true;
      },
      onRemoveNewTranslation() {
        this.isAddTranslation = false;
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-translations {
    box-sizing: border-box;
    position: relative;
    .loader-wrap {
      position: absolute;
      top: 4rem;
      width: 100%;
      .loader {
        position: relative;
        margin: auto;
        width: 1.8rem;
        height: 1.8rem;
      }
    }
  }
</style>
